module.exports = __webpack_public_path__ + "static/logo-7682be80a1bce24d07316f97482f66ef.png";